import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Believability() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 md:py-24 bg-gradient-to-br from-sage-primary/10 to-white" data-id="element-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="relative bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-18">
          <QuoteIcon className="absolute top-6 left-6 w-12 h-12 text-sage-primary/20" data-id="element-19" />
          <div className="relative z-10" data-id="element-20">
            <p className="font-serif text-2xl md:text-3xl text-forest leading-relaxed mb-6" data-id="element-21">
              En los primeros 7 días, lo primero que notarás no es solo el peso,
              sino la desinflamación.
            </p>
            <p className="text-lg text-forest/80 leading-relaxed" data-id="element-22">
              El rostro se ve más descansado y esa sensación de pesadez después
              de comer desaparece por completo. Es el primer signo de que tu
              interruptor metabólico se ha encendido.
            </p>
          </div>
        </div>
      </div>
    </motion.section>;
}